export const createQueryString = (params: Record<string, string | string[]>): string => {
  const urlParams = new URLSearchParams();

  for (const [key, value] of Object.entries(params)) {
    if (Array.isArray(value)) {
      for (const item of value) {
        urlParams.append(key, item);
      }
    } else if(key !== 'pg') {
      urlParams.append(key, value);
    } else if (key === 'pg' && value >= '2') {
      urlParams.append(key, value);
    }
  }

  return urlParams.toString();
};

export const getQueryParams = (searchParams: URLSearchParams) => {
  const paramsObject = {};
  if (searchParams) {
    for (const key of searchParams.keys()) {
      paramsObject[key] = searchParams.getAll(key);
    }
  }
  return paramsObject;
};

export const createQueryStringValue = (name: string, value: string, searchParams: URLSearchParams) => {
  const params = new URLSearchParams(searchParams?.toString());
  params.set(name, value);

  return params.toString();
};

export const createUrl = (pathname: string, params: string) => (params ? `${pathname}?${params}` : pathname);
